module.exports = __webpack_public_path__ + "img/bayern-munich.f9ba3050.png";